import { BaseService, BaseServiceConstructor } from 'api/services/base.service';
import { plainToInstance } from 'class-transformer';
import { AsyncJob } from 'types/responses/AsyncJob';
import { JobAction, Job, JobStatus } from '@cast/leadcast-types';

interface JobCount {
  totalCount: number;
}

export class JobService extends BaseService {
  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
  }

  async getJobById(jobId: string): Promise<Job> {
    const { data } = await this.publicHttpClient.get<Job>(`/jobs/${jobId}`, {
      withCredentials: false,
    });
    return plainToInstance(AsyncJob, data);
  }

  async getJobsCount(config: {
    tenants?: string | string[];
    actions?: JobAction | JobAction[];
    actionCondition?: 'in' | 'not-in';
    status?: JobStatus | JobStatus[];
    statusCondition?: 'in' | 'not-in';
    startDate?: Date | string;
  }): Promise<JobCount> {
    const { data } = await this.tenantlessPublicHttpClient.get<JobCount>('/jobs/count', {
      withCredentials: false,
      params: {
        tenants: config.tenants,
        action: config.actions,
        actionCondition: config.actionCondition,
        status: config.status,
        statusCondition: config.statusCondition,
        startDate: config.startDate,
      },
    });

    return data;
  }
}
